import { useFormStore } from "@ariakit/react";

export function useForm<T extends Record<string, unknown>>(props: {
  defaultValues: T;
  onSubmit: (values: T) => void | Promise<void>;
}) {
  const form = useFormStore({
    defaultValues: props.defaultValues,
  });

  form.useSubmit(({ values }) => {
    void props.onSubmit(values);
  });

  return form;
}
